"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperSearchIcon = exports.StyledSearchIconButton = exports.StyledLoupeImg = exports.StyledInputLabel = exports.StyledIconButton = exports.StyledFormControl = exports.StyledBtnSearchLabel = exports.InputSearch = exports.Divider = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _material = require("@mui/material");

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

/* istanbul ignore next */
var StyledInputLabel = (0, _styledComponents.default)(_material.InputLabel)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.17;\n  letter-spacing: normal;\n  opacity: 0.7;\n  top: -12px;\n  left: -13px;\n  &.Mui-focused {\n    color: inherit;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.secondary.main;
});
/* istanbul ignore next */

exports.StyledInputLabel = StyledInputLabel;
var StyledFormControl = (0, _styledComponents.default)(_material.FormControl)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n  vertical-align: top;\n  min-height: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  &:hover {\n    border-color: ", ";\n  }\n"])), function (_ref2) {
  var withborder = _ref2.withborder;
  return withborder ? '38px' : '40px';
}, function (_ref3) {
  var withborder = _ref3.withborder,
      theme = _ref3.theme;
  return withborder ? theme.palette.color.darkIndigo : 'none';
}, function (_ref4) {
  var withborder = _ref4.withborder;
  return withborder ? '4px' : 'none';
}, function (_ref5) {
  var withborder = _ref5.withborder,
      theme = _ref5.theme;
  return withborder ? theme.palette.secondary.main : 'none';
});
/* istanbul ignore next */

exports.StyledFormControl = StyledFormControl;

var WrapperSearchIcon = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: baseline;\n  pointer-events: none;\n  padding-right: 22px;\n  "])));
/* istanbul ignore next */


exports.WrapperSearchIcon = WrapperSearchIcon;

var Divider = _styledComponents.default.div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n", "\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return "\n  width: 10px;\n  height: 22px;\n  border-left: 1px solid ".concat(theme.palette.color.darkGrey, ";\n  margin-right: 7px;\n  ");
});
/* istanbul ignore next */


exports.Divider = Divider;
var InputSearch = (0, _styledComponents.default)(_material.InputBase)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n", "\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return "\n  color: inherit;\n  margin-top: 0;\n  margin-left: 14px;\n  width: 100%;\n  ::placeholder {\n    text-overflow: ellipsis !important;\n    color: ".concat(theme.palette.secondary.main, ";\n    // font-size: 12px;\n  }\n\n  ").concat(theme.breakpoints.down('md'), " {\n    margin-left: 6px;\n  }\n  ");
});
exports.InputSearch = InputSearch;
var StyledIconButton = (0, _styledComponents.default)(_IconButton.default)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n", "\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return "\n  color: ".concat(theme.palette.color.blueLight, ";\n  border: 1px solid ").concat(theme.palette.color.blueLight, ";\n  opacity: 0.6;\n  border-radius: 50%;\n  margin-right: 20px;\n  &:hover {\n    border: 1px solid ").concat(theme.palette.color.white, ";\n    opacity: 1;\n  }\n\n  ").concat(theme.breakpoints.down('md'), " {\n    margin: 0 10px 0 10px;\n  }\n  ");
});
exports.StyledIconButton = StyledIconButton;
var StyledSearchIconButton = (0, _styledComponents.default)(_IconButton.default)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n", "\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return "\n  color: ".concat(theme.palette.color.blueLight, " !important;\n  border: 1px solid ").concat(theme.palette.color.blueLight, ";\n  opacity: 0.6;\n  border-radius: 100px;\n  margin-right: 12px;\n  padding-right: 20px;\n  padding-left: 20px;\n  &:hover {\n    border: 1px solid ").concat(theme.palette.color.white, ";\n    opacity: 1;\n    .MuiTypography-root {\n      opacity: 0.5;\n    }\n  }\n  ");
});
exports.StyledSearchIconButton = StyledSearchIconButton;
var StyledBtnSearchLabel = (0, _styledComponents.default)(_material.Typography)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return "\n    font-size: 16px;\n    font-weight: 300;\n    line-height: 0;\n    margin-right: 15px;\n    color: ".concat(theme.palette.color.blueLight, ";\n    opacity: 1;\n  ");
});
exports.StyledBtnSearchLabel = StyledBtnSearchLabel;

var StyledLoupeImg = _styledComponents.default.img(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  cursor: pointer;\n"])));

exports.StyledLoupeImg = StyledLoupeImg;